// extracted by mini-css-extract-plugin
export var job = "peopleJobs-module--job--3jztU";
export var jobCopy = "peopleJobs-module--jobCopy--1xEkq";